import { salesforceRedirectIfNeeded, installSalesforceEmbedHistoryPushStatePatch } from './embed-client-pure';

// Fix the URL first (handles back-button reloads) before patching history
salesforceRedirectIfNeeded();
installSalesforceEmbedHistoryPushStatePatch();
